import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgEyecreamGlyph from './svgs/EyecreamGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var eyecreamGlyph = (props => useIcon(SvgEyecreamGlyph, SvgEyecreamGlyph, props));

export { eyecreamGlyph as default };
